<template>
  <div class="flex flex-col w-full" :class="detailed ? 'mt-12' : ''">
    <div>
      <h2 v-if="!detailed" class="mb-3 md:text-3xl text-2xl font-black">{{ $t('itinerary') }}</h2>
      <p class="mb-4">{{ $t('select_number_days') }}</p>
      <div class="flex mb-10">
        <slot></slot>
      </div>
      <h2 v-if="detailed" class="text-2xl lg:text-3xl font-black mb-10">{{ $t('itinerary_to_country')}} {{ landing.name }} - {{ itineraries[itinerarySelected].days }} {{$t('days')}}</h2>
    </div>
    <!-- {{ itineraries[itinerarySelected].steps}} -->
    <div class="flex flex-col">
      <transition-group name="list" tag="div">
        <div v-for="(step, index) in itineraries[itinerarySelected].steps" :key="index">
          <div class="flex mb-5" :class="detailed ? '' : 'border-b border-lightGrey'">
            <div class="circle-step font-bold mb-3" :class="detailed ? 'circle-step-detail mr-3' : 'mr-5'">{{ step.step }}</div>
            <div class="flex flex-col mb-2">
              <span class="text-lg font-black" :class="detailed ? 'mb-2' : 'mb-0'">{{ step.title }}</span>
              <span v-if="detailed">{{ step.description }}</span>
            </div>
          </div>
          <img class="mb-8 rounded-xlg w-full" v-if="detailed" :src="step.image" :alt="step.title">
        </div>
      </transition-group>
    </div>
  </div>
</template>

<script lang="ts">
export default {
  props: {
    itinerarySelected: {
      type: Number
    },
    itineraries: {
      type: Array
    },
    detailed: {
      type: Boolean,
      default: false
    },
    landing: {
      type: Object,
    }
  },
}
</script>
<style lang="scss">
@import "../../../sass/variables";
.circle-step {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  background-color: $turquoiseBullet;

  &-detail {
    width: 30px;
    padding: 0 15px;

  }
}
</style>
